"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExclusionaryOptionsValue = isExclusionaryOptionsValue;
function isExclusionaryOptionsValue(options) {
    return 'exclude' in options || 'locked' in options;
}
